import React from "react";
import about from "./about.module.css";
import progress from "../../../Assets/About/about us.svg";
import ProgressBar from "@ramonak/react-progress-bar";
import CountUp from "react-countup";
import {
  FaBuilding,
  FaRegBuilding,
  FaUserTie,
  FaUserGraduate,
  FaDatabase,
  FaPlus,
} from "react-icons/fa";
import userimg from "../../../Assets/About/team2.png";


const Progress = () => {
  return (
    <div className={about.Progress_container}>
      {/* <h3>Company Overview</h3> */}
      <div className={about.child_container}>
        <div
          className={about.progress_img_container}
          data-aos="fade-down"
          data-aos-easing="linear"
          data-aos-duration="1500"
        >
          <img src={progress} alt="image" className={about.progresImg} />
        </div>
        <div
          className={about.prog_text_container}
          data-aos="fade-up"
          data-aos-easing="linear"
          data-aos-duration="1500"
        >
          <p className={about.ptext}>Company Overview</p>
          <h1 className={about.pheader}>
            About Kohere Connect Private Limited
          </h1>
          <p className={about.pbodytext}>
            At Kohere Connect Private Limited, we are dedicated to transforming
            the way businesses access and manage critical data, compliance
            services, financial resources, and market presence. As a one-stop
            solution for the business marketplace, we specialize in offering
            comprehensive services across Finance, Risk Management, Compliance,
            Personal Finance, and IPO/Stock Market Listing.
          </p>
          {/* <div className={about.progressbars_container}>
            <p className={about.Progress1}>
              <span className={about.percenteage}>
                <span className={about.servicelable}>Customer Service</span>15%
              </span>
              <ProgressBar
                completed={60}
                isLabelVisible={false}
                bgColor="var(--PrimaryColor)"
              />
            </p>
            <p className={about.Progress1}>
              <span className={about.percenteage}>
                <span className={about.servicelable}>Customer Service</span>20%
              </span>
              <ProgressBar
                completed={60}
                isLabelVisible={false}
                bgColor="var(--PrimaryColor)"
              />
            </p>
          </div> */}
          <div className={about.bottom_container}>
            {/* <button type="button" className={about.connectbtn}>
              Discover More
            </button> */}
            <div className={about.user_container}>
              {/* <div className={about.user_img_container}>
                <img src={userimg} alt="image" className={about.userIMG} />
              </div>
              <p className={about.usertext_cont}>
                <p className={about.usertext1}>Eleanor Pena</p>
                <p className={about.usertext2}>Founder & CEO</p>
              </p> */}
            </div>
          </div>
        </div>
      </div>
      {/* <div className={about.second_chind}>
        <div className={about.countcontainer}>
          <div className={about.iconbox}>
            <FaBuilding size={40} className={about.countImg} />
          </div>
          <div className={about.counttext}>
            <p className={about.countable}>
              <CountUp end={27} suffix=" Lakh" />
              <sup>
                <FaPlus size={15} />
              </sup>
            </p>
            <p className={about.countabletext}>Companies Data</p>
          </div>
        </div>

        <div className={about.countcontainer}>
          <div className={about.iconbox}>
            <FaRegBuilding size={40} className={about.countImg} />
          </div>
          <div className={about.counttext}>
            <p className={about.countable}>
              <CountUp end={3} suffix=" Lakh" />
              <sup>
                <FaPlus size={15} />
              </sup>
            </p>
            <p className={about.countabletext}>LLP Data</p>
          </div>
        </div>

        <div className={about.countcontainer}>
          <div className={about.iconbox}>
            <FaUserTie size={40} className={about.countImg} />
          </div>
          <div className={about.counttext}>
            <p className={about.countable}>
              <CountUp end={50} suffix=" Lakh" />
              <sup>
                <FaPlus size={15} />
              </sup>
            </p>
            <p className={about.countabletext}>Directors Data</p>
          </div>
        </div>

        <div className={about.countcontainer}>
          <div className={about.iconbox}>
            <FaUserGraduate size={40} className={about.countImg} />
          </div>
          <div className={about.counttext}>
            <p className={about.countable}>
              <CountUp end={10} suffix=" Lakh" />
              <sup>
                <FaPlus size={15} />
              </sup>
            </p>
            <p className={about.countabletext}>Professionals Data</p>
          </div>
        </div>

        <div className={about.countcontainer}>
          <div className={about.iconbox}>
            <FaDatabase size={40} className={about.countImg} />
          </div>
          <div className={about.counttext}>
            <p className={about.countable}>
              <CountUp end={500} />
              <sup>
                <FaPlus size={15} />
              </sup>
            </p>
            <p className={about.countabletext}>Data Sources</p>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default Progress;
